import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilty, AppMetadataHandler } from 'app';
import { PolicyService } from 'app/FunctionalModules';
import { InvestigationService } from 'app/BaseFramework/core/http/investigation.service';
import { DatePipe } from '@angular/common';
import { DataTransformService } from 'app/ViewModules/shared-services/data-transform/data-transform.service';
import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-ui-analytics-tab',
  templateUrl: './ui-analytics-tab.component.html',
  styleUrls: ['./ui-analytics-tab.component.scss'],
  providers: [DatePipe]
})

export class UiAnalyticsTabComponent implements OnInit {
  
  _fraudPropensity: any;
  _earlyClaimProbability: any;
  inputData : any;
  _recommendation : any;
  @Input() mode:string = "panel"; /* panel or tab */
  @Input() set workQueueItem(value){
    if(value) {
      this.inputData = value;
      // this.fetchFraudDeatils();
    }
  };
  @Input() set fraud (value:number){
    if(value){
      this._fraudPropensity = value;
    }
  }
  @Input() set propensityScore (value:number){
    if(value){
      this._earlyClaimProbability = value;
    }
  }

  @Input() set recommendation(value : string){
    if(value){
      this._recommendation = value;
    }
  }
  _IO
  @Input()
  set IO(value) {
    
    if (value) {
      this._IO = this.ServerToUITransform(value);

      this._IO = value;
      this.clientDoList=this.getClientDOlistWithRole(this._IO)
      let listOfPrimaryInsured = this.commonUtility.extractClientDOFromIOGeneric(value, 'PRIMARYINSURED');
    this.primaryInsured = listOfPrimaryInsured ? listOfPrimaryInsured[0] ? listOfPrimaryInsured[0] : null : null
    }
  }
  clientDoList  
  primaryInsured = null
  userDetails

  constructor(private commonUtility: CommonUtilty,
    private policyService: PolicyService,
    private investigationService: InvestigationService,
    public appMetadataHandler: AppMetadataHandler,
    private datePipe: DatePipe,
    public dataTransformService : DataTransformService,
    private apiRequestService : ApiRequestService,
    private msg : NzMessageService) { }

  ngOnInit() {
    // this.fraudPropensity = this.commonUtility.generateRandom(85, true);
    //this.earlyClaimProbScore = Number(this.fraudPropensity + this.commonUtility.generateRandom(5, true));
    this.fetchCaseDataByGuid();
    
    if(this._earlyClaimProbability){
      this.earlyClaimProbability = this._earlyClaimProbability
    }
    if(this._fraudPropensity){
      this.fraudPropensity = this._fraudPropensity
    }
    if(this.primaryInsured && this.primaryInsured.name){
      let details = this.dataSet.filter(item=> item.name == this.primaryInsured.name)
      this.userDetails = details && this.commonUtility.isArrayIterable(details) ? details[0] ? details[0] : this.dataSet[0] : this.dataSet[0]
    }
  }

  getClientDOlistWithRole(IO) {
    let output = []
  if (IO) {
    let PRIMARYINSUREDLIST = this.commonUtility.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
    let INSUREDLIST = this.commonUtility.extractClientDOListFromIOGeneric(IO, 'INSURED');
    if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
      output.push(...PRIMARYINSUREDLIST);
    if (INSUREDLIST && Array.isArray(INSUREDLIST))
      output.push(...INSUREDLIST)
  }
  return output
  }
  fraudDeatils : any;
  ServerToUITransform(payload) {
    return payload;
  }

  fetchFraudDeatils(){
    let url = 'fetchBatchLog'
    let pathVariables = [];
    pathVariables.push(this.inputData.proposalNum);
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp =>{
      if(resp)
        this.fraudDeatils = resp
      else this.msg.error("Server Error : Please check with system administrator")

      if(this.fraudDeatils && this.commonUtility.isArrayIterable(this.fraudDeatils)){
        this.fraudDeatils.forEach(detail => {
          if(detail.batchName && detail.batchName == 'PROBABILITY'){
            let propensityRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.dataTransformService.propensityRisk = propensityRespData[0] ? propensityRespData[0].claim_prediction_years ? propensityRespData[0].claim_prediction_years : null : null;
          }
          if(detail.batchName && detail.batchName == 'FWA_RISK'){
            let fraudScoreRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.dataTransformService.fraudRisk = fraudScoreRespData[0] ? fraudScoreRespData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            this.dataTransformService.fraudScore = fraudScoreRespData[0] ? fraudScoreRespData[0].predictionProbabilityPercent ? fraudScoreRespData[0].predictionProbabilityPercent : null : null;
            this.recommendation = fraudScoreRespData[0] ? fraudScoreRespData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
            this.dataTransformService.riskRecommendation = this.recommendation;
          }
          if(detail.batchName && detail.batchName == 'UW_RISK'){
            let UWRiskData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.dataTransformService.riskSummary = UWRiskData[0]['content'] ? UWRiskData[0]['content'] : null;
            // this.modelPrediction = UWRiskData[0] ? UWRiskData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            // this.recommendation = UWRiskData[0] ? UWRiskData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
          }
        })
      } else {
        this.msg.error("No Data in Resp!!!");
      }
    })
  }
  /* Functions for getting Gauge values */
  //earlyClaimProbScore: number = 0;
  //getEarlyClaimProbScore = (percent: number) => `${percent}`;

  fraudPropensity:number = 0;

  fraudRisk = 'Low';
  getClaimRisk  = (percent: number) => {
    let risk = 'Low';
    if(percent >= 66)
      risk = 'High'
    else if (percent > 33 && percent <= 66 )
      risk =  'Medium'
    else{
      risk = 'Low'
    }
    this.fraudRisk = risk;
    return risk;
  };
  getFraudPropensity = (percent: number) => `${percent}`;

  fetchCaseDataByGuid() {
    if (this.workQueueItem && this.workQueueItem['guid']) {
      this.policyService.getCaseByGuid(this.workQueueItem['guid']).subscribe(response => {
        if(response){
          this.predictEarlyClaim(response);
        }
        //if (response)
          //this.autuUWRules = response.autoUwResults;
      })
    }
  }

  noPredictionMsg: string;
  earlyClaimProbability: string;
  earlyClaimProbabilityYear: string;
  getEarlyClaimPrediction : boolean = false;

  predictEarlyClaim(response) {
    if (response && response['caseDO']) {
      this.getEarlyClaimPrediction = true;
      let caseDO = response['caseDO'];

      let req_payload = {
        "product_type": "LIFE_Claims_Dev",
        "business_process": "FWARISKANALYSIS",
        "module_name": "VisionIntelligence",
        "input_data": {
          "CASE_NUMBER": caseDO['proposalNum'],
          "PRODUCT_NAME": caseDO['baseProductCd'],
          "POLICY_START_DATE": caseDO['policyCommencementDt'] ? this.getDateData(new Date(caseDO['policyCommencementDt'])) : null,
          "TERM": caseDO['policyTerm'] || 1,
          "POLICY_EXPIRY_DT": this.getExpiryDate(caseDO['policyCommencementDt'], caseDO['policyExpiryDt'], caseDO['policyTerm']),
          "Primary_Insured_AGE": 43,
          "Primary_Insured_Gender": 1,
          "Primary_Insured_Height": 166,
          "Primary_Insured_Weight": 85,
          "Insured_AGE": 24,
          "Gender": "Male",
          "Height": 187,
          "Weight": 76,
          "SUM_INSURED": caseDO['sumInsuredAmt'] || 100000,
          "Other_Policies": this.commonUtility.isArrayIterable(caseDO['othercases']) ? 'Yes' : 'No',
          "Claim taken": "Yes",
          "BMI": 31,
          "Claim_taken_Time": "1 years",
          "SMOKER": "N",
          "Alcoholic": "N",
          "diabetic": "N",
          "Hypertension": "N"
        }
      }

      this.investigationService.predictEarlyClaim(req_payload).subscribe(resp => {
        if (resp && Object.keys(resp).length) {
          this.noPredictionMsg = null;
          this.earlyClaimProbabilityYear = resp.claim_prediction_years;
          this.earlyClaimProbability = this.getEarlyClaimProbability(resp.claim_prediction_years);
          this.getEarlyClaimPrediction = false;
        } else {
          this.noPredictionMsg = 'Unexpected error occurred. Please try again later or contact your system administrator.';
          this.getEarlyClaimPrediction = false;
        }
      }, (e) => {
        console.log("error occurred for similar case search: ", e)
        this.getEarlyClaimPrediction = false;
      });

    }
  }

  generateEarlyClaimScore(claim_predicted_years){
    if(claim_predicted_years <= 1){
      return Math.floor(Math.random() * (99 - 75 + 1)) + 75;
    }
    else if(claim_predicted_years > 1 && claim_predicted_years <=3){
     return Math.floor(Math.random() * (74 - 50 + 1)) + 50;
    }
    else{
      return Math.floor(Math.random() * (49 - 10 + 1)) + 10;
    }
  }

  getEarlyClaimProbability  = (predictedData) => {
    let risk = 'Low';
    if(predictedData >= 75)
      risk = 'High'
    else if (predictedData < 74 && predictedData >= 50)
      risk =  'Medium'
    else{
      risk = 'Low'
    }
    return risk;
  };

  getDateData(dateValue){
    return this.datePipe.transform(dateValue, 'dd/MM/yyyy');
  }

  getExpiryDate(startDate, expiryDate, term) {
    if (expiryDate) {
      return this.getDateData(new Date(expiryDate))
    } else if (startDate) {
      let diff = term || 1;
      let date = new Date(startDate);
      date.setFullYear(date.getFullYear() + diff);
      return  this.getDateData(date)
    } else {
      return null;
    }
  }
  dataSet = [
    {
      key    : '1',
      name   : 'John Doe',
      message: "Accept with standard premium rates."
    },
    {
      key    : '2',
      name   : 'Alice Smith',
      message: "Reject as Cancer reported, which significantly increases health risks.",
      
    },
    {
      key    : '3',
      name   : 'Dan Miller',
      message: "Accept with Revised Terms. Monitor tobacco consumption and manage diabetes effectively. Consider follow-up health checks.",
      
    },
    {
      key    : '4',
      name   : 'Liem Kim',
      message: "Accept with Revised Terms. Reduced Sum Assured due to existing policy.",
      
    },
  ]

}
